import { LanguageService } from './../../Services/languageService';
import { Subscription } from 'rxjs';
import { userService } from './../../Services/userService';
import { TravelstatusMdl } from './../../Models/TravelBindMdl';
import { MedmalProposalModel } from './../../Models/MedmalProposalModel';
import { TravelProposalMdl } from './../../Models/TravelProposalMdl';
import { TravelRegMdl } from './../../Models/TravelRegMdl';
import { MotorStatusMdl } from './../../Models/MotorStatusMdl';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { restURL } from '../../Models/restURL';
import { motorProposalService } from '../../Services/motorProposalService';
import { ProposalModel, mdlProposalCancelReq_DH, PayfortTransInfoModel } from '../../Models/ProposalModel'
import { RegModel } from '../../Models/RegModel';
import { proposalListPipe } from '../../Pipes/ProposalListPipe'
import { MedmalRegMdl } from '../../Models/MedmalRegMdl';
import { MedmalstatusMdl } from '../../Models/MedmalProposal';
import { TravelReportModel } from './../../Models/TravelReportModel';
import { MedMalReportModel } from '../../Models/MedMalReport';
import { mdlPayloadRequest } from '../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../Models/mdlPayloadResponse';
import Swal from 'sweetalert2';
import { mdlProposalList_DH } from '../../Models/mdlProposalList_DH';
import { mdlStatus_DH } from '../../Models/mdlStatus_DH';
import { TranslateService } from '@ngx-translate/core';
import { mdlPaymentDetailsReq_DH } from '../../Models/mdlPaymentDetailsReq_DH';
import { mdlPaymentDetailsRes_DH } from '../../Models/mdlPaymentDetailsRes_DH';
import { mdlGetEditProposalDetailsReq } from '../../Models/mdlGetEditProposalDetailsReq';
import { mdlProposalSaveReq } from '../../Models/mdlProposalSaveReq';
import { BindMdl } from '../../Models/BindMdl';
import { MotorProposal } from '../../Models/MotorProposal';
import * as $ from 'jquery';
import { APIService } from '../../Services/api.service';
import { mdlProposalSaveRes } from '../../Models/mdlGetPayfortFieldsReq';

@Component({
  selector: 'Proposals',
  templateUrl: './Proposals.html',
  styleUrls: ['./Proposals.css']
})
export class Proposals {

  public License: boolean;
  public OTP: boolean;
  public Vehicle: boolean;
  public Count: number = 1;
  public Motor: boolean;

  public st: MotorStatusMdl = new MotorStatusMdl();
  public medmalst: MedmalstatusMdl = new MedmalstatusMdl();
  public SelectedType: string;
  public regObj: RegModel = new RegModel();
  public proposalList: Array<ProposalModel> = new Array<ProposalModel>();
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public travelRegObj: RegModel = new RegModel();
  public medmalRegObj: RegModel = new RegModel();
  public travelProposalList: Array<TravelProposalMdl> = new Array<TravelProposalMdl>();
  // public medmalProposalList: Array<MedmalProposalModel> = new Array<MedmalProposalModel>();
  public Travelrptobj: TravelReportModel = new TravelReportModel();
  public Medmalrptobj: MedMalReportModel = new MedMalReportModel();
  public isShowLoading: boolean = false;
  public FilePath: string;
  public LngSubscription: Subscription;
  public Lng: string;
  public ProposalLan: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public DomesticProposalList: Array<mdlProposalList_DH> = new Array<mdlProposalList_DH>();
  public objMdlSt_Dh: mdlStatus_DH = new mdlStatus_DH();
  public objPaymentDetailsRes_DH: mdlPaymentDetailsRes_DH = new mdlPaymentDetailsRes_DH();
  public objGetEditProDet_DH: mdlGetEditProposalDetailsReq = new mdlGetEditProposalDetailsReq()
  public objProposal: mdlProposalSaveReq = new mdlProposalSaveReq();
  disDiv: any;

  public medmalProposalList:any;
  public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();



  constructor(public Translate: TranslateService, private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: motorProposalService, private userinfo: userService, private lngService: LanguageService,
    private APISer: APIService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng;
      if (this.Lng != null) {
        this.ProposalLan = this.Lng == "ar" ? "A" : "E";
      }
    });
    this.ProposalLan = 'E'
    if (sessionStorage.getItem("Language") != null) {
      this.ProposalLan = sessionStorage.getItem("Language") == "ar" ? "A" : "E";
    }

    this.isShowLoading = true;
    this.getProposalList();
    this.getTravelPendingProposals();
    this.getMedmalPendingProposals();
    this.GetProposalList_DH();
    this.isShowLoading = false;
    // $("body").addClass("TEXT")

    // $(".TEXT").click(function() {
    //   $("#InsuranceModel .dropdownTEXT ul").css("background-color", "red" );

    // })
  }
  // goforPayment(proposal) {
  //   sessionStorage.setItem("paymentObj", JSON.stringify(proposal));
  //   sessionStorage.setItem("NavFrom", "PRB");
  //   sessionStorage.setItem("fpCode", "5515");
  //   this.router.navigate(['NewDashboard/PayfortPayment']);
  // }
  goforPayment(proposal, product) {
    if (localStorage.getItem("Channel") == "Kiosk") {
      Swal(this.Translate.instant("You Can Also Follow The Link Which We Sent To Your Mobile To Proceed Further"));
    }
    if (proposal.ProposalType == 'UPGRADE') {
      this.router.navigate(['NewDashboard/PayfortPaymentUpgrade/:DashBoard']);
    }
    else {
      if (product == "5515") {
        if (proposal.IsTplComplete == 1) {
          this.isShowLoading = true;

          let obj = {
            UserId : "331",
            ProposalNo:proposal.ProposalNo,
            ProductCode:product           
          }
          this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(obj));

          //this.http.post<Array<ProposalModel>>(this.url.baseURL + "/PolicySettings/getProposalList", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
          this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Quote/GetProposalSaveRes", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {

            this.isShowLoading = false;
            //New Line Start
            this.objPayloadResponse = result;
            let objPropSaveRes: mdlProposalSaveRes = new mdlProposalSaveRes();
            objPropSaveRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

            if (objPropSaveRes.StatusCode != "S") {
              Swal(objPropSaveRes.StatusDesc, "", "error")
              return;
            }
            //NewLine End
          },
          (error) => {
            this.isShowLoading = false;
            this.userinfo.checkTokenStatus(error);
          });         
          
          sessionStorage.setItem("paymentObj", this.EncriptService.EncriptObject(JSON.stringify(proposal)));
          sessionStorage.setItem("NavFrom", "PRB");
          sessionStorage.setItem("fpCode", "5515");

          this.router.navigate(['NewDashboard/PayfortPayment']);
        }
        else {
          sessionStorage.setItem("newPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(proposal.newPolicyObj)));

          this.BindInfo(proposal, product)
        }
      }
      else if (product == "5520") {
        if (proposal.IsCompComplete == 1) {
          this.isShowLoading = true;
          
          let obj = {
            UserId : "331",
            ProposalNo:proposal.ProposalNo,
            ProductCode:product   
          }
          this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(obj));

          //this.http.post<Array<ProposalModel>>(this.url.baseURL + "/PolicySettings/getProposalList", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
          this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Quote/GetProposalSaveRes", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {

            this.isShowLoading = false;
            //New Line Start
            this.objPayloadResponse = result;
            let objPropSaveRes: mdlProposalSaveRes = new mdlProposalSaveRes();
            objPropSaveRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

            if (objPropSaveRes.StatusCode != "S") {
              Swal(objPropSaveRes.StatusDesc, "", "error")
              return;
            }
            //NewLine End
          },
          (error) => {
            this.isShowLoading = false;
            this.userinfo.checkTokenStatus(error);
          });   

          sessionStorage.setItem("paymentObj", this.EncriptService.EncriptObject(JSON.stringify(proposal)));
          sessionStorage.setItem("NavFrom", "PRB");
          sessionStorage.setItem("fpCode", "5515");
          this.router.navigate(['NewDashboard/PayfortPayment']);
        }
        else {
          sessionStorage.setItem("newPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(proposal.newPolicyObj)));
          this.BindInfo(proposal, product)
        }
      }



    }




  }


  goforMedmalPayment(proposal) {
    //sessionStorage.setItem("MedmalpaymentObj", JSON.stringify(proposal));
    sessionStorage.setItem("MedmalpaymentObj", this.EncriptService.EncriptObject(JSON.stringify(proposal)));
    sessionStorage.setItem("NavFrom", "PRB");
    sessionStorage.setItem("fpCode", "5014");
    this.router.navigate(['NewDashboard/PayfortPayment']);
  }

  goforTravelPayment(proposal) {
    this.isShowLoading = true;
    
    let obj = {
      UserId : "331",
      ProposalNo:proposal.ProposalNo,
      ProductCode:proposal.ProductCode   
    }
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(obj));

    //this.http.post<Array<ProposalModel>>(this.url.baseURL + "/PolicySettings/getProposalList", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Quote/GetProposalSaveRes", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {

      this.isShowLoading = false;
      //New Line Start
      this.objPayloadResponse = result;
      let objPropSaveRes: mdlProposalSaveRes = new mdlProposalSaveRes();
      objPropSaveRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

      if (objPropSaveRes.StatusCode != "S") {
        Swal(objPropSaveRes.StatusDesc, "", "error")
        return;
      }
      //NewLine End
    },
    (error) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(error);
    });

    sessionStorage.setItem("TravelpaymentObj", JSON.stringify(proposal));
    sessionStorage.setItem("NavFrom", "PRB");
    sessionStorage.setItem("fpCode", "6001");
    this.router.navigate(['NewDashboard/PayfortPayment']);
  }

  getProposalList() {

    this.isShowLoading = true;
    this.regObj.RegNo = this.userinfo.EncriptString(sessionStorage.getItem("RegNo")).toString();
    this.regObj.token = sessionStorage.getItem("token");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.regObj));

    //this.http.post<Array<ProposalModel>>(this.url.baseURL + "/PolicySettings/getProposalList", this.regObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getProposalList", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {

      this.isShowLoading = false;
      //New Line Start
      this.objPayloadResponse = result;
      let objResObj: Array<ProposalModel> = new Array<ProposalModel>();
      objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));


      this.proposalList = objResObj;





      if (objResObj.length > 0) {
        if (this.userinfo.EncriptString(objResObj[0].transObj.RegNo).toString() != this.regObj.RegNo) {
          Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
          this.router.navigate(['BeforeLogin/NewReg']);
          return;
        }
      }

      //NewLine End

    },
      (error) => {
        //this.isShowLoading=false;
        this.userinfo.checkTokenStatus(error);
      });

  }

  goForEdit(Proposal) {

    if (Proposal.ProposalType == "NEW") {
      sessionStorage.setItem("newPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(Proposal.newPolicyObj)));
      sessionStorage.setItem("CurrentRoute", "InsuredInfo");
      this.router.navigate(['./NewDashboard/MotorProposalForm/InsuredInfo']);
    }
    else if (Proposal.ProposalType == "RENEWAL") {
      sessionStorage.setItem("renewObj", this.EncriptService.EncriptObject(JSON.stringify(Proposal.renewPolicyObj)));
      sessionStorage.setItem("CurrentRoute", "RenewalBasicInfo");
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalBasicInfo']);
    }
  }

  CancelProposal(cancelObj) {

    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(cancelObj));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/CancelMotorProposal", cancelObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Proposal/CancelMotorProposal", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;
      this.isShowLoading = false;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);

      this.getProposalList();
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });

  }




  getMedmalPendingProposals_old() {
    // this.isShowLoading=true;
    this.medmalRegObj.RegNo = sessionStorage.getItem("RegNo");
    this.medmalRegObj.token = sessionStorage.getItem("token");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.medmalRegObj));
    //this.http.post<Array<MedmalProposalModel>>(this.url.baseURL + "/PolicySettings/getMedmalProposals", this.medmalRegObj, this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getMedmalProposals", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise()
      .then((result) => {
        this.isShowLoading = false;
        //this.medmalProposalList = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.medmalProposalList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End


        //this.isShowLoading=false;
      }, (error) => {
        // this.isShowLoading=false;
        this.userinfo.checkTokenStatus(error);
      });


  }

  goForMedmalEdit(Proposal) {
    if (Proposal.ProposalType == "NEW") {
      Proposal.newPolicyObj.IqamaNo = sessionStorage.getItem("IqamaNo");
      //sessionStorage.setItem("newMedmalPolicyObj", JSON.stringify(Proposal.newPolicyObj));
      sessionStorage.setItem("newMedmalPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(Proposal.newPolicyObj)));
      sessionStorage.setItem("IsMedMalEdit", "Y");
      sessionStorage.setItem("CurrentRoute", "MedmalNewProposal");
      this.router.navigate(['./NewDashboard/MedmalNewProposal']);

    }
  }

  goForMedmalCancel(cancelObj) {
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(cancelObj));

    //this.http.post<MedmalstatusMdl>(this.url.baseURL + "/MedmalBind/CancelProposal", cancelObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/MedmalBind/CancelProposal", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.medmalst = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.medmalst = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      this.Lng == "ar" ? Swal(this.medmalst.StatusDescAr) : Swal(this.medmalst.StatusDescEn);

      this.isShowLoading = false;
      this.getMedmalPendingProposals();
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);


      });
  }

  // goForTravelEdit(Proposal) {

  //   if (Proposal.ProposalType == "NEW") {
  //     //sessionStorage.setItem("newTravelPolicyObj", JSON.stringify(Proposal.newPolicyObj));
  //     sessionStorage.setItem("newTravelPolicyObj", this.EncriptService.EncriptObject(JSON.stringify(Proposal.newPolicyObj)));
  //     sessionStorage.setItem("IsTravelEdit", "Y");
  //     sessionStorage.setItem("CurrentRoute", "TravelPolicy");
  //     this.router.navigate(['./NewDashboard/TravelPolicy']);

  //   }
  // }

  goForTravelCancel(cancelObj) {
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(cancelObj));

    //this.http.post<TravelstatusMdl>(this.url.baseURL + "/travelBind/CancelTravelProposal", cancelObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/travelBind/CancelTravelProposal", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);

      this.isShowLoading = false;
      this.getTravelPendingProposals();
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);
      });
  }

  getTravelPendingProposals() {
    //this.isShowLoading=true;
    this.travelRegObj.RegNo = sessionStorage.getItem("RegNo");
    this.travelRegObj.token = sessionStorage.getItem("token");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.travelRegObj));

    //this.http.post<Array<TravelProposalMdl>>(this.url.baseURL + "/PolicySettings/getTravelProposals", this.travelRegObj, this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/getTravelProposals", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise()
      .then((result) => {
        //this.travelProposalList = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.travelProposalList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End

        // this.isShowLoading=false;
      }, (error) => {
        //  this.isShowLoading=false;        
        this.userinfo.checkTokenStatus(error);

      });
  }

  DownloadProposalPrint(ProposalNo) {
    this.FilePath = "";

    this.isShowLoading = true;
    this.Travelrptobj.Lng = sessionStorage.getItem("Language");
    this.Travelrptobj.ProposalNo = ProposalNo;

    this.http.post<TravelstatusMdl>(this.url.baseURL + "/Proposal/generateTravelProposalPrint", this.Travelrptobj, this.userinfo.getHttpOptions())
      .toPromise()
      .then((result) => {
        this.st = result;
        if (this.st.StatusCode == "S") {
          window.open(this.url.reportURL + "/" + this.st.Result);
        }
        else {
          Swal("Policy Document Not found");
        }

        this.isShowLoading = false;
      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);

      });
  }

  DownloadMedMalProposalPrint(ProposalNo) {

    this.FilePath = "";
    this.isShowLoading = true;
    this.Medmalrptobj.Lng = sessionStorage.getItem("Language");
    this.Medmalrptobj.ProposalNo = ProposalNo;

    this.http.post<MedmalstatusMdl>(this.url.baseURL + "/Proposal/generateMedmalProposalPrint", this.Medmalrptobj, this.userinfo.getHttpOptions())
      .toPromise()
      .then((result) => {
        this.medmalst = result;
        if (this.medmalst.StatusCode == "S") {

          window.open(this.url.reportURL + "/" + this.medmalst.Remarks);
        }
        else {
          Swal("Policy Document Not found");
        }

        this.isShowLoading = false;
      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);

      });
  }

  GetProposalList_DH() {
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(sessionStorage.getItem("RegNo")));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/PolicySettings/GetProposalList_DH", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise()
      .then((result) => {
        this.objPayloadResponse = result;
        this.DomesticProposalList = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      }, (error) => {
        this.userinfo.checkTokenStatus(error);

      });
  }

  ProposalCancel_DH(ValProposalNo) {
    this.isShowLoading = true;
    let cancelObj: mdlProposalCancelReq_DH = new mdlProposalCancelReq_DH();
    cancelObj.ProposalNo = ValProposalNo;
    cancelObj.RegNo = sessionStorage.getItem("RegNo");
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(cancelObj));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/DomesticHelper/ProposalCancel_DH", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.objPayloadResponse = result;
      this.isShowLoading = false;
      this.objMdlSt_Dh = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      Swal(this.Translate.instant(this.objMdlSt_Dh.StatusDesc));
      if (this.objMdlSt_Dh.StatusCode == "S") {
        sessionStorage.removeItem("DomesticProposal");
      }
      this.GetProposalList_DH();
    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);


      });
  }

  GoForPayment_DH(ValProposalNo) {

    this.isShowLoading = true;
    let objReq: mdlPaymentDetailsReq_DH = new mdlPaymentDetailsReq_DH();
    objReq.ProposalNo = ValProposalNo;
    objReq.RegNo = sessionStorage.getItem("RegNo");
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(objReq));

    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/DomesticHelper/GetPaymentDetails_DH", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
      this.objPayloadResponse = result;
      this.isShowLoading = false;
      this.objPaymentDetailsRes_DH = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));

      if (this.objPaymentDetailsRes_DH.StatusCode == "S") {
        sessionStorage.setItem("PaymentDetails_DH", this.EncriptService.EncriptObject(JSON.stringify(this.objPaymentDetailsRes_DH)));
        sessionStorage.setItem("NavFrom", "PRB");
        sessionStorage.setItem("fpCode", "5018");
        this.router.navigate(['NewDashboard/PayfortPayment']);
      }
      else { Swal(this.Translate.instant(this.objPaymentDetailsRes_DH.StatusDesc)); return; }


    },
      (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);


      });



  }

  ProposalEdit_DH(ValProposalNo) {

    this.objGetEditProDet_DH.ProposalNo = ValProposalNo;
    this.objGetEditProDet_DH.RegNo = sessionStorage.getItem("RegNo");
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objGetEditProDet_DH));
    this.isShowLoading = true;
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/DomesticHelper/GetEditProposalDetails_DH", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.isShowLoading = false;
        this.objPayloadResponse = result;
        this.objProposal = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        if (this.objProposal.StatusCode == "S") {
          if (this.objProposal.Insured_PostalCode == 0) { this.objProposal.Insured_PostalCode = null }
          if (this.objProposal.RiskDetails[0].PoBoxNo == 0) { this.objProposal.RiskDetails[0].PoBoxNo = null }

          sessionStorage.setItem("DomesticProposal", this.EncriptService.EncriptObject(JSON.stringify(this.objProposal)));
          this.router.navigate(['NewDashboard/DomesticInsuredInfo']);
        }
        else { Swal(this.Translate.instant(this.objProposal.StatusDesc)); return; }

      },
        (error) => {
          this.isShowLoading = false;
          Swal(error);
        });
  }


  BindInfo(Proposal, product) {

    try {

      this.isShowLoading = true;

      Proposal.newPolicyObj.RegNo = sessionStorage.getItem("RegNo");

      Proposal.newPolicyObj.RegNo = this.userinfo.EncriptString(Proposal.newPolicyObj.RegNo).toString();
      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(Proposal.newPolicyObj));
      //this.http.post<BindMdl>(this.url.baseURL + "/newPolicy/bindInfo", this.newPolicyReq, this.userinfo.getHttpOptions())
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/newPolicy/bindInfo", this.objPayloadRequest, this.userinfo.getHttpOptions())
        .toPromise().then((result) => {
          this.isShowLoading = false;
          //New Line Start
          this.objPayloadResponse = result;

          let bindObj: BindMdl = new BindMdl();
          let prObj: MotorProposal = new MotorProposal();
          bindObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
          if (this.userinfo.EncriptString(bindObj.MotorProposalObj.RegNo).toString() != Proposal.newPolicyObj.RegNo) {
            Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
            this.router.navigate(['BeforeLogin/NewReg']);
            return;
          }

          //NewLine End

          if (bindObj.st.StatusCode == "F") {
            this.Lng == "ar" ? Swal(bindObj.st.StatusDescAr) : Swal(bindObj.st.StatusDesc);
            return;
          }


          prObj = bindObj.MotorProposalObj;
          prObj.ProductCode = product;
          prObj.SelectedProductCode = product;
          if (product == "5515") { prObj.isTPLSelected = true; }
          else if (product == "5520") { prObj.isCompSelected = true; }

          this.proposalService.saveProposalObj(prObj);
          this.proposalService.saveBindObj(bindObj);
          this.proposalService.sendProposal(prObj);
          this.proposalService.sendBindInfo(bindObj);

          sessionStorage.setItem("mp", "Y");
          sessionStorage.setItem("CurrentRoute", "VehicleDetails");
          this.router.navigate(['NewDashboard/MotorProposalForm/VehicleDetails']);

        },
          (error) => {
            this.isShowLoading = false;
            this.userinfo.checkTokenStatus(error);
          })

    }
    catch (error) {
      this.isShowLoading = false;
      Swal(error.message)
    }
  }

  btnClick(idx) {
    this.disDiv = idx;
  }

  hidePopup() {
    this.disDiv = null;
  }

  goForTravelEdit(Proposal) {
    window.open('https://lbc.ggi-sa.com/TravelLive/#/Landing', "_blank")
  }



  async getMedmalPendingProposals() {

    let Req = {
      RegNo : sessionStorage.getItem("RegNo"),
      InsuredId: sessionStorage.getItem("IqamaNo"),
      Lng : sessionStorage.getItem("Lng"),
    }
 
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/LimraMedmal/GetMedmalProposalList", Req)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    if(APIRes[1].StatusCode=="F"){
      Swal(APIRes[1].StatusDesc, "", "error")
    }

    let Res = APIRes[1];
    if(Res.st.StatusCode == "S"){
      this.medmalProposalList = Res.medmalProposalList;
    }else{
      Swal(Res.st.StatusDescEn, "", "error")
    }
  }

  async CancelMedmalQuoteConfirm(proposalno:any){

    let obj = { 
      RegNo: sessionStorage.getItem("RegNo"), 
      ProposalNo: proposalno 
    }

    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/Limra/CancelMedmalQuote", obj)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    let Res = APIRes[1];

    if (Res.StatusCode == "S") {
      Swal(this.Translate.instant(Res.StatusDesc), "", "success");
      this.getMedmalPendingProposals();
    }
    else {
      Swal(this.Translate.instant(Res.StatusDesc), "", "error");
    }
  }



  async GetPaymentFields(Proposal: any, product: any) {
    let RegNo: any = sessionStorage.getItem("RegNo");
  
    let obj = {
      UserId : RegNo,
      ProductCode:product,
      ProposalNo:Proposal
    }
    this.isShowLoading = true;
    var APIRes = await this.APISer.ConnectAPI("/Quote/GetProposalSaveRes", obj)
    this.isShowLoading = false;
    var APIStatus = APIRes[0]
    if (APIStatus.StatusCode == "F") {
      Swal(APIStatus.StatusDesc, "", "error")
      return;
    }
    let objPropSaveRes: mdlProposalSaveRes = new mdlProposalSaveRes();
    objPropSaveRes = APIRes[1];
    if (objPropSaveRes.StatusCode != "S") {
      Swal(objPropSaveRes.StatusDesc, "", "error")
      return;
    }
    this.transObj.ProposalNo = objPropSaveRes.PaymentObj.ProposalNo;
    this.transObj.InsuredName= objPropSaveRes.PaymentObj.InsuredName;
    this.transObj.Premium= objPropSaveRes.PaymentObj.TotalPremium;
    this.transObj.ProductCode= objPropSaveRes.PaymentObj.ProductCode;
    this.transObj.EPayInfo= objPropSaveRes.PaymentObj.PaySign;
    this.transObj.Mobile= objPropSaveRes.PaymentObj.MobileNo;
    this.transObj.RegNo=objPropSaveRes.PaymentObj.UserId;

    sessionStorage.setItem("NavFrom", "PR");
    this.isShowLoading = true;
    sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
    this.router.navigate(['/NewDashboard/PayfortPayment']);
  }

  StatusCss(Status:any){
    if (Status == "Active") {
      return { 'color': 'green'}
  }
  if (Status == "Expired") {
      return { 'color': 'red'}
  }
  return {}
  }

}







// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Proposals/Proposals.ts